import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import backIcon from "include/images/chevron-left.svg";
import crashGameImg from "include/images/crash-game.png";
import loadingIcon from "include/images/loader-grey.svg";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { msToHMS } from "utils/misc";
import AllUserEngagementFlyer from "../flyers/allUserEngagementFlyer";
import ViewAllFlyer from "../flyers/viewAllFlyer";
import {
  getTelegram,
  loadZedRunDashboard,
  loadZedRunTopLosers,
  loadZedRunTopUsersByTimeSpent,
  loadZedRunTopWinners,
} from "store/telegram";
import userIcon from "include/images/user.png";

const TelegramZedRunStats = (props) => {
  const ref = useRef();
  const [type, setType] = useState("winner");
  const [showViewAll, setShowViewAll] = useState(false);
  const [showAllUserEngagement, setShowAllUserEngagement] = useState(false);
  const [loadingMain, setLoadingMain] = useState(true);
  useEffect(() => {
    props.loadZedRunDashboard(() => setLoadingMain(false));
    props.loadZedRunTopWinners({ page: 1 });
    props.loadZedRunTopLosers({ page: 1 });
    props.loadZedRunTopUsersByTimeSpent({ page: 1 });
  }, []);
  const {
    zedRunDashboard,
    zedRunTopWinners,
    zedRunTopWinnersLoading,
    zedRunTopWinnersPagination,
    zedRunTopLosers,
    zedRunTopLosersPagination,
    zedRunTopLosersLoading,
    zedRunTopUsersByTimeSpent,
    zedRunTopUsersByTimeSpentPagination,
    zedRunTopUsersByTimeSpentLoading,
  } = props.getTelegram;

  useEffect(() => {
    if (!loadingMain) ref?.current?.complete();
    else ref?.current?.continuousStart();
  }, [loadingMain]);

  const toggleViewAll = (e, type) => {
    e.preventDefault();
    if (type) setType(type);
    setShowViewAll(!showViewAll);
  };
  const toggleViewUserEngagement = (e) => {
    e.preventDefault();
    setShowAllUserEngagement(!showAllUserEngagement);
  };
  return (
    <>
      <Header />
      <Loader loaderRef={ref} />
      <div className="page-wrapper add-dev-server-wrapper">
        <SideBar page="telegram-mini-app-luckGame-zrun" />
        {!loadingMain && (
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Zed Run Crash Game</h1>
            </div>
            <div className="fwc-wrapper">
              <Link
                to="#"
                className="back-link-btn"
                onClick={(e) => {
                  e.preventDefault();
                  props.history.goBack();
                }}
              >
                <img src={backIcon} alt="" /> Back
              </Link>
              <div className="grid-card-details-row d-flex flex-wrap">
                <div className="gcdr-img-box">
                  <div className="gcdr-img-outer text-white">
                    <div className="gcdr-image">
                      <img src={crashGameImg} alt="" />
                    </div>
                    <div className="gcdr-group d-flex flex-wrap">
                      <div className="gcdr-item flex-grow-1 w-auto">
                        <h6>{msToHMS(parseInt(zedRunDashboard?.totalTimeSpend))}</h6>
                        <p>
                          <strong>Time Spend</strong>
                        </p>
                      </div>
                      <div className="gcdr-item flex-grow-1 w-auto">
                        <h6>{zedRunDashboard?.onlineUsers?.toLocaleString("en-us") ?? 0}</h6>
                        <p>
                          <strong>ONLINE USERS</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="gcdr-widget-wrapper">
                    <div className="gcdr-widget-box">
                      <h4>Details</h4>
                      <div className="gcdr-details-box">
                        <div className="gcdr-details-item d-flex align-items-center justify-content-between">
                          <div>Total Games Played</div>
                          <div>{zedRunDashboard?.completedRound?.toLocaleString("en-us") ?? 0}</div>
                        </div>
                        <div className="gcdr-details-item d-flex align-items-center justify-content-between">
                          <div>Unique Players</div>
                          <div>{zedRunDashboard?.totalPlayer?.toLocaleString("en-us") ?? 0}</div>
                        </div>
                        <div className="gcdr-details-item d-flex align-items-center justify-content-between">
                          <div>Games per Player</div>
                          <div>
                            {zedRunDashboard?.gamePerPlayerRatio?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) ?? 0}
                          </div>
                        </div>
                        <div className="gcdr-details-item d-flex align-items-center justify-content-between">
                          <div>Bets per Player</div>
                          <div>
                            {zedRunDashboard?.betPerPlayerRatio?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) ?? 0}
                          </div>
                        </div>
                        <div className="gcdr-details-item d-flex align-items-center justify-content-between">
                          <div>Empty Rounds with No Players</div>
                          <div>{zedRunDashboard?.emptyRound?.toLocaleString("en-us") ?? 0}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="gcdr-text-box">
                  <div className="gcdr-heading d-flex align-items-center justify-content-between">
                    <h2>Zed Run Crash Game</h2>
                  </div>

                  <div className="gcdr-widget-wrapper mt-2">
                    <div className="gcdr-widget-box">
                      <ul className="gw-list d-flex flex-wrap">
                        <li>
                          <div className="gw-box">
                            <em>Total Rounds</em>
                            <h6>{zedRunDashboard?.totalRound?.toLocaleString("en-us") ?? 0}</h6>
                          </div>
                        </li>
                        <li>
                          <div className="gw-box">
                            <em>Available Rounds</em>
                            <h6>{zedRunDashboard?.availableRounds?.toLocaleString("en-us") ?? 0}</h6>
                          </div>
                        </li>
                        <li>
                          <div className="gw-box">
                            <em>Completed Rounds</em>
                            <h6>{zedRunDashboard?.completedRound?.toLocaleString("en-us") ?? 0}</h6>
                          </div>
                        </li>
                        <li>
                          <div className="gw-box">
                            <em>Total Bet Amount</em>
                            <h6>
                              {zedRunDashboard?.totalBetAmount?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) ?? 0}
                            </h6>
                          </div>
                        </li>
                        <li>
                          <div className="gw-box">
                            <em>Total Amount Won</em>
                            <h6>
                              {zedRunDashboard?.totalWinningAmount?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) ?? 0}
                            </h6>
                          </div>
                        </li>
                        <li>
                          <div className="gw-box">
                            <em>BG Profit</em>
                            <h6>
                              {zedRunDashboard?.BGProfit?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) ?? 0}
                            </h6>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="gcdr-widget-box">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4>Top 10 Winners</h4>{" "}
                        <Link to="#" className="back-link-btn m-0" onClick={(e) => toggleViewAll(e, "winner")}>
                          View all
                        </Link>
                      </div>
                      <div className="table-responsive">
                        <table className="table custom-table-striped">
                          <thead>
                            <tr>
                              <th>User</th>
                              <th>No of Times Bets Placed</th>
                              <th>Points Spent</th>
                              <th>Points Won</th>
                              <th>Profit/Loss</th>
                            </tr>
                          </thead>
                          <tbody>
                            {zedRunTopWinners?.length > 0 &&
                              zedRunTopWinners?.map((winner, index) => (
                                <tr key={winner?._id}>
                                  <td>
                                    <span>
                                      <div className="td-img-group d-flex align-items-start ">
                                        <div className="td-img round-img m-right-2">
                                          <img
                                            src={
                                              winner?.user?.image
                                                ? process.env.REACT_APP_CDN + winner?.user?.image?.small
                                                : userIcon
                                            }
                                            alt=""
                                          />
                                        </div>
                                        <div>
                                          {winner?.user?.firstName} {winner?.user?.lastName}
                                          <br />
                                          {winner?.user?.userName} <br />
                                          {winner?.user?.telegramId}
                                        </div>
                                      </div>
                                    </span>
                                  </td>
                                  <td>{winner?.totalBetsPlaced}</td>
                                  <td>
                                    {winner?.totalBetAmount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                  <td>
                                    {winner?.totalWinningAmount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                  <td>
                                    {winner?.profitDifference?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {zedRunTopWinners?.length === 0 &&
                          (zedRunTopWinnersLoading ? (
                            <div className="w-100 d-flex justify-content-center load-more">
                              <img src={loadingIcon} className="fa-spin" alt="" />
                            </div>
                          ) : (
                            <div className="nfr-box">No Records Found!</div>
                          ))}
                      </div>
                    </div>
                    <div className="gcdr-widget-box">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4>Top 10 Losers</h4>
                        <Link to="#" className="back-link-btn m-0" onClick={(e) => toggleViewAll(e, "loser")}>
                          View all
                        </Link>
                      </div>
                      <div className="table-responsive">
                        <table className="table custom-table-striped">
                          <thead>
                            <tr>
                              <th>User</th>
                              <th>No of Times Bets Placed</th>
                              <th>Points Spent</th>
                              <th>Points Won</th>
                              <th>Profit/Loss</th>
                            </tr>
                          </thead>
                          <tbody>
                            {zedRunTopLosers?.length > 0 &&
                              zedRunTopLosers?.slice(0, 10)?.map((loser, index) => (
                                <tr key={loser?._id}>
                                  <td>
                                    <span>
                                      <div className="td-img-group d-flex align-items-start ">
                                        <div className="td-img round-img m-right-2">
                                          <img
                                            src={
                                              loser?.user?.image
                                                ? process.env.REACT_APP_CDN + loser?.user?.image?.small
                                                : userIcon
                                            }
                                            alt=""
                                          />
                                        </div>
                                        <div>
                                          {loser?.user?.firstName} {loser?.user?.lastName}
                                          <br />
                                          {loser?.user?.userName} <br />
                                          {loser?.user?.telegramId}
                                        </div>
                                      </div>
                                    </span>
                                  </td>
                                  <td>{loser?.totalBetsPlaced}</td>
                                  <td>
                                    {loser?.totalBetAmount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                  <td>
                                    {loser?.totalWinningAmount?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                  <td>
                                    {loser?.profitDifference?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }) ?? 0}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {zedRunTopLosers?.length === 0 &&
                          (zedRunTopLosersLoading ? (
                            <div className="w-100 d-flex justify-content-center load-more">
                              <img src={loadingIcon} className="fa-spin" alt="" />
                            </div>
                          ) : (
                            <div className="nfr-box">No Records Found!</div>
                          ))}
                      </div>
                    </div>
                    <div className="gcdr-widget-box">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4>User Engagement</h4>
                        <Link to="#" className="back-link-btn m-0" onClick={toggleViewUserEngagement}>
                          View all
                        </Link>
                      </div>
                      <div className="table-responsive">
                        <table className="table custom-table-striped">
                          <thead>
                            <tr>
                              <th>User</th>
                              <th>Total Time Spent</th>
                            </tr>
                          </thead>
                          <tbody>
                            {zedRunTopUsersByTimeSpent?.length > 0 &&
                              zedRunTopUsersByTimeSpent?.slice(0, 10)?.map((user, index) => (
                                <tr key={user?._id}>
                                  <td>
                                    <span>
                                      <div className="td-img-group d-flex align-items-start ">
                                        <div className="td-img round-img m-right-2">
                                          <img
                                            src={
                                              user?.user?.image
                                                ? process.env.REACT_APP_CDN + user?.user?.image?.small
                                                : userIcon
                                            }
                                            alt=""
                                          />
                                        </div>
                                        <div>
                                          {user?.user?.firstName} {user?.user?.lastName}
                                          <br />
                                          {user?.user?.userName} <br />
                                          {user?.user?.telegramId}
                                        </div>
                                      </div>
                                    </span>
                                  </td>
                                  <td>{msToHMS(user?.totalSpendTime)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {zedRunTopUsersByTimeSpent?.length === 0 &&
                          (zedRunTopUsersByTimeSpentLoading ? (
                            <div className="w-100 d-flex justify-content-center load-more">
                              <img src={loadingIcon} className="fa-spin" alt="" />
                            </div>
                          ) : (
                            <div className="nfr-box">No Records Found!</div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ViewAllFlyer
        type={type}
        players={type === "winner" ? zedRunTopWinners : zedRunTopLosers}
        loadMore={type === "winner" ? props.loadZedRunTopWinners : props.loadZedRunTopLosers}
        pagination={type === "winner" ? zedRunTopWinnersPagination : zedRunTopLosersPagination}
        showModal={showViewAll}
        toggleModal={toggleViewAll}
      />
      <AllUserEngagementFlyer
        topUsersByTimeSpent={zedRunTopUsersByTimeSpent}
        loadMore={props.loadZedRunTopUsersByTimeSpent}
        pagination={zedRunTopUsersByTimeSpentPagination}
        showModal={showAllUserEngagement}
        toggleModal={toggleViewUserEngagement}
      />
      {(showViewAll || showAllUserEngagement) && (
        <div
          className="modal-backdrop show fade"
          onClick={showViewAll ? toggleViewAll : toggleViewUserEngagement}
        ></div>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
  loadZedRunDashboard: (callback) => dispatch(loadZedRunDashboard(callback)),
  loadZedRunTopWinners: (pramas, fresh, callback) => dispatch(loadZedRunTopWinners(pramas, fresh, callback)),
  loadZedRunTopLosers: (pramas, fresh, callback) => dispatch(loadZedRunTopLosers(pramas, fresh, callback)),
  loadZedRunTopUsersByTimeSpent: (params, fresh, callback) =>
    dispatch(loadZedRunTopUsersByTimeSpent(params, fresh, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TelegramZedRunStats));
